import React from 'react';
import GridStyledList from 'components/GridStyledList';

import image1 from 'images/content/icons/Affordable-Insurance-Plans.png'
import image2 from 'images/content/icons/Straightforward-Underwriting-Process.png'
import image3 from 'images/content/icons/Quality-Customer-Service.png'
import image4 from 'images/content/icons/Critical-Illness-Health-Coverage.png'
import image5 from 'images/content/icons/Simple-Comparison-Shopping.png'
import image6 from 'images/content/icons/Automatic-Re-Enrollment.png'

const SixthSection = () => {

    const header = 'Choose the Right Group Health Insurance Plan'

    const sixthSectionContent = [
        {
            icon: image1,
            title: 'Affordable Insurance Options for Businesses',
            body: 'As a business owner, you have to watch every penny. We help you find insurance plans that stay within your budget while giving your employees quality coverage.'
        },
        {
            icon: image2,
            title: 'We Are Your Health Insurance Advocate',
            body: 'If you ever have problems dealing with the insurance provider regarding billing, claims, enrollment, or other issues, we advocate for you to find a solution.'
        },
        {
            icon: image3,
            title: 'Unbiased Assistance in Choosing Your Plan',
            body: 'We perform accurate and unbiased research to show you the best plans available right now. You choose which plan you want based on the most current information.'
        },
        {
            icon: image4,
            title: 'Responsive Customer Service',
            body: 'We provide numerous ways to reach us so that we are available to you during the moments when you rely on us the most. You can count on our customer service.'
        },
        {
            icon: image5,
            title: 'We Compare Providers for You',
            body: 'Part of the headache of getting health insurance is comparing providers. Let our experts compare insurance companies and find the best plans and rates for you.'
        },
        {
            icon: image6,
            title: 'Automatic Re-Enrollment',
            body: 'Forgot to re-enroll? No problems. Our system automatically renews your enrollment. We send you notifications to alert you so that you can update your plan as needed.'
        },
    ]

    return (
        <GridStyledList content={sixthSectionContent} header={header} />
    );
}

export default SixthSection;
